import { useEffect, useState } from 'react';
import StatusMessage from './StatusMessage';

function LoginForm({ onSubmit, status }) {
  const [credentials, setCredentials] = useState({ userId: '', password: '' });

  useEffect(() => {
    if (status?.type === 'success') {
      setCredentials({ userId: '', password: '' });
    }
  }, [status?.type]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(credentials);
  };

  const isLoading = status?.type === 'loading';

  return (
    <>
      <div className="card-header">
        <h1>تسجيل الدخول</h1>
        {/* <p>يرجى إدخال بيانات الحساب.</p> */}
      </div>

      <form className="form" onSubmit={handleSubmit}>
        <label htmlFor="userId">رقم المستخدم</label>
        <input
          id="userId"
          name="userId"
          type="text"
          placeholder="أدخل رقم المستخدم"
          value={credentials.userId}
          onChange={handleChange}
          autoComplete="username"
        />

        <label htmlFor="password">كلمة المرور</label>
        <input
          id="password"
          name="password"
          type="password"
          placeholder="أدخل كلمة المرور"
          value={credentials.password}
          onChange={handleChange}
          autoComplete="current-password"
        />

        <button type="submit" disabled={isLoading}>
          {isLoading ? 'جارٍ التحقق...' : 'تسجيل الدخول'}
        </button>
      </form>

      <StatusMessage type={status?.type} message={status?.message} />
    </>
  );
}

export default LoginForm;

